import { getParsedStorageItem, saveToStorage } from 'helpers/playersMatching'
import { STORAGE_KEYS, CARD_TYPES } from './constants'

export class AnnouncementsStatusModel {
    readAnnouncements = {}
    readNews = {}

    displayedAnnouncements = {}
    displayedNews = {}

    constructor() {
        this.readAnnouncements = getParsedStorageItem(STORAGE_KEYS.READ_ANNOUNCEMENTS) || {}
        this.readNews = getParsedStorageItem(STORAGE_KEYS.READ_NEWS) || {}
    }

    getAnnouncementKey(item) {
        return (
            item.type === CARD_TYPES.ANNOUNCEMENTS &&
            `${item.message_id}_${item.created_at}`
        ) || (
            item.type === CARD_TYPES.NEWS &&
            item.news_id
        )
    }

    getReadItems(item) {
        return item.type === CARD_TYPES.ANNOUNCEMENTS ? this.readAnnouncements : this.readNews
    }

    getDisplayedItems(item) {
        return item.type === CARD_TYPES.ANNOUNCEMENTS ? this.displayedAnnouncements : this.displayedNews
    }

    saveReadAnnouncements() {
        saveToStorage(STORAGE_KEYS.READ_ANNOUNCEMENTS, this.readAnnouncements)
        saveToStorage(STORAGE_KEYS.READ_NEWS, this.readNews)
    }

    markAllDisplayedAsRead() {
        this.readAnnouncements = Object.assign({}, this.readAnnouncements, this.displayedAnnouncements)
        this.readNews = Object.assign({}, this.readNews, this.displayedNews)
    }

    markAsRead(item) {
        this.getReadItems(item)[this.getAnnouncementKey(item)] = true
    }

    markAsDisplayed(item) {
        this.getDisplayedItems(item)[this.getAnnouncementKey(item)] = true
    }

    isRead(item) {
        return item.type === CARD_TYPES.CREATE_NEW_ANNOUNCEMENT ||
            this.getReadItems(item)[this.getAnnouncementKey(item)]
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/AnnouncementsStatusModel.js